<template>
  <v-form lazy-validation ref="form" @submit.prevent="validate">
    <div class="md-scrollbar">
      <div class="md-layout md-gutter md-alignment-center">
        <div
          class="md-layout-item md-xlarge-size-40 md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100"
        >
          <div class="picture-container">
            <div class="picture">
              <!-- https://metastation-dev.oss-cn-hangzhou.aliyuncs.com/avatar/dev/18e52881a930428b2ae1679875740cc5/%C3%A5%C2%BE%C2%AE%C3%A4%C2%BF%C2%A1%C3%A5%C2%9B%C2%BE%C3%A7%C2%89%C2%87_20211209133610.jpg -->
              <!-- <div v-if="user.hasOwnProperty('avatar')&&JSON.stringify(user)!=='{}'"> -->
              <!-- <img src="" class="picture-src" title="" /> -->
              <img
                class="picture-src"
                :src="logImg == '' ? require('/public/img/faces/vue-logo.png') : logImg"
              />
              <!-- </div> -->
              <!-- <div v-else>
                                <img :src="require('/public/img/faces/avatar.jpg')" />
                            </div> -->
              <input type="file" @change="upload" />
            </div>
            <h6 class="description">选择头像</h6>
          </div>
        </div>
        <div
          class="md-layout-item md-xlarge-size-60 md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100"
        >
          <!-- <v-text-field v-model="setForm.id"  label="修改节点类型" hint="修改节点类型"></v-text-field>
                     <md-button  @click="Updatas">点击修改 </md-button> -->
          <v-text-field
            v-model="user.username"
            disabled
            label="帐号"
            hint="帐号为邮箱或手机号码"
            :rules="rules.username"
          ></v-text-field>
          <!-- <v-text-field v-model="user.password" label="密码" hint="请输入密码" :rules="rules.passwordRule"></v-text-field> -->
          <v-text-field
            v-model="user.email"
            label="邮箱"
            hint="邮箱可以为空，若输入则必须为邮箱格式"
            :rules="rules.emailRule"
          ></v-text-field>
          <v-text-field
            v-model="user.phone"
            label="手机"
            hint="手机可以为空，若输入则必须为手机格式"
            :rules="rules.phoneRule"
          ></v-text-field>
        </div>
      </div>
    </div>
    <v-snackbar v-model="snackbar" top color="green">
      {{ mesgText }}
    </v-snackbar>
  </v-form>
</template>
<script>
import { upDateTaskType } from '@/api/task/task';
import kit from '/common/js/kit.js';
import { upload, userInfo } from '@/api/user';
import { SlideYDownTransition } from 'vue2-transitions';
const regMobileExp = new RegExp(/^1[3-9]\d{9}$/);
const regEmailExp = new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/);

export default {
  components: {
    SlideYDownTransition,
  },
  props: {
    avatar: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      setForm: {
        id: '',
      },
      snackbar: false,
      mesgText: '',
      logImg: '',
      uid: '',
      password: '',
      repassword: '',
      file: '',
      active: false,
      user: Object,
      rules: {
        username: [value => !!value || '帐号不能为空.'],
        passwordRule: [value => !!value || '密码不能为空.'],
        phoneRule: [
          v => {
            return v ? regMobileExp.test(v) || '请输入正确的手机号.' : true;
          },
        ],
        emailRule: [
          v => {
            return v ? regEmailExp.test(v) || '请输入正确的邮箱.' : true;
          },
        ],
      },
    };
  },
  created() {
    this.uid = this.$route.query.uid || '';
    this.userInfo();
    console.log('--------------------->账号页面');
  },
  methods: {
    Updatas() {
      upDateTaskType({
        projectId: this.setForm.id,
      }).then(res => {
        console.log(res, '------------------------------');
      });
    },
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.$emit('on-validated', {
          step: 'step1',
          userData: this.user,
        });
        return true;
      }
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = e => {
        // this.user.avatar = e.target.result;
      };
      reader.readAsDataURL(file);
      let type = file.type.split('/') && file.type.split('/')[1] ? file.type.split('/')[1] : '';
      if (!['jpeg', 'jpg', 'png'].includes(type)) {
        this.$message.warning('请选择正确的图片格式');
        return;
      }
      let formData = new FormData();
      formData.append('avatar', file);
      // let params = configApi.upload(formData);
      // params.headers = { 'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq' };
      // api.$axios(params).then(res => {
      //     if (res.data.code === '200') {
      //         this.user.avatar = res.data.data;
      //         this.$message.success('上传成功');
      //     }
      // }).catch(() => {});
      upload(formData).then(res => {
        if (res.code === '200') {
          this.logImg = res.data.url;
          this.user.user.avatar = res.data.url;
          this.$emit('setlogImg', res.data.url);
          this.message(true, '上传成功');

          // this.$message.success('上传成功');
        }
      });
    },
    message(flag, text) {
      this.snackbar = flag;
      this.mesgText = text;
    },
    getUser() {
      return this.user;
    },
    userInfo() {
      let tempData = {
        uid: this.uid,
      };
      userInfo(tempData).then(res => {
        this.$store.commit('permission/SET_USER', res.data.user);
        if (res.code === '200') {
          this.user = { ...this.user, ...res.data };
          let { avatar, accountNumber, password, email, phoneNumber } = this.user.user;
          if (this.user.user.avatar) {
            this.logImg = avatar;
          }
          this.user.username = accountNumber;
          // this.user.password = password
          this.user.email = email;
          this.user.phone = phoneNumber;
          kit.setUserInfo(this.user);
        }
      });
    },
  },
};
</script>
<style>
.set-password-box {
  box-sizing: border-box;
  padding: 20px;
}

.picture-src {
  width: 100%;
  height: 100% !important;
}
</style>